import type {
    CatalogUerBaseCostData,
    CatalogUerBaseCostEstimateBasisItem,
    CatalogUerBaseCostWorkScopeBaseData,
} from 'gql/graphql';

export interface IUseCatalogData {
    activeTabId: Tabs;
    catalogUniqueId: string | undefined;
    uerBaseCostId: number | undefined;
}

export interface ICatalogUerBaseCostScopesModal {
    onClose: () => void;
    catalogUniqueId?: string;
    rowData?: CatalogUerBaseCostData | null;
}

export interface IColumns {
    activeTabId: Tabs;
    onFiltersUpdated: ({ fieldName, checkedValues }: { fieldName: string; checkedValues: string[] }) => void;
    currentFilterData: (CatalogUerBaseCostWorkScopeBaseData | CatalogUerBaseCostEstimateBasisItem)[] | null;
}

export type TNestedColumns = Pick<IColumns, 'onFiltersUpdated' | 'currentFilterData'>;

export enum Tabs {
    WORK_SCOPES = 'workScopes',
    ESTIMATE_BASIS = 'estimateBasis',
    ESTIMATE_BASIS_RESOURCES = 'estimateBasisResources',
}

export const tabsItems = [
    {
        id: Tabs.WORK_SCOPES,
        label: 'Состав работ',
    },
    {
        id: Tabs.ESTIMATE_BASIS,
        label: 'Состав ресурсов',
    },
    {
        id: Tabs.ESTIMATE_BASIS_RESOURCES,
        label: 'Машины, механизмы, рабочие',
    },
];
